// extracted by mini-css-extract-plugin
export default {"ctn":"parts_ctn__syimF","textBox":"parts_textBox__YiTNJ","gridColumns":"parts_gridColumns__kGLwo","gridRows":"parts_gridRows__im04Z"};